import { WriterContentsRoutes } from '@/modules/shared/routes/writer/contents'
import { WriterFinancialRoutes } from '@/modules/shared/routes/writer/financial'
import { WriterInfoRoutes } from '@/modules/shared/routes/writer/info'
import { WriterSupportRoutes } from '@/modules/shared/routes/writer/support'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterRoutes {
  constructor(
    public readonly supports: WriterSupportRoutes,
    public readonly info: WriterInfoRoutes,
    public readonly financial: WriterFinancialRoutes,
    public readonly contents: WriterContentsRoutes
  ) {
  }

  index() {
    return Ziggy
      .route('writer.index')
      .toString()
  }

  dashboard() {
    return Ziggy
      .route('writer.dashboard')
      .toString()
  }
}
